import * as Icons from "../icons";
import { FC } from "react";
import { IconName } from "../../types/icons";

type AppIconProps = {
  name: IconName;
} & Icons.IconProps;

export const AppIcon: FC<AppIconProps> = ({ name, ...props }) => {
  const IconComponent = Icons[name] as FC<Icons.IconProps> | undefined;

  return IconComponent ? <IconComponent {...props} /> : null;
};
